import React, { forwardRef } from "react";
import ReactPlayer from "react-player";
import {
  MediaController,
  MediaControlBar,
  MediaTimeRange,
  MediaTimeDisplay,
  MediaFullscreenButton,
  MediaPipButton,
  MediaPosterImage,
} from "media-chrome/react";
import { MediaType } from "shared-types";
import { PipIcon, FullScreenPlayerIcon } from "assets";
import PlayButton from "pages/Profile/components/common/MediaPlayer/components/PlayButton";
import VolumeControl from "pages/Profile/components/common/MediaPlayer/components/VolumeControl";
import "./styles.scss";

interface PlayerProps {
  src: string;
  title?: string;
  poster?: string;
  type?: MediaType;
}

export interface PlayerControls {
  media: HTMLVideoElement;
}

const Player = forwardRef<PlayerControls, PlayerProps>(
  ({ title, src, poster, type }, ref) => {
    return (
      <MediaController
        style={{
          width: "100%",
          aspectRatio: "16/9",
          borderRadius: 16,
        }}
        // @ts-expect-error ref type mismatch
        ref={ref}
        className="media-controller"
      >
        <ReactPlayer
          slot="media"
          src={src}
          controls={false}
          style={{
            width: "100%",
            height: "auto",
            aspectRatio: "16/9",
            // @ts-expect-error css prop
            "--controls": "none",
          }}
        />

        {poster && <MediaPosterImage slot="poster" src={poster} />}

        {type === MediaType.Audio && (
          <div className="h-full w-full bg-[linear-gradient(180deg,#2741E8_0%,#20016B_100%)]" />
        )}

        <div className="z-1 absolute inset-0 flex items-center justify-center">
          <PlayButton isPrimary />
        </div>

        <div className="absolute bottom-0 left-0 mt-1 flex w-full flex-col gap-2 bg-[linear-gradient(0deg,rgba(0,0,0,0.8)_0%,rgba(0,0,0,0.6)_50%,rgba(0,0,0,0)_100%)]">
          <MediaTimeRange className="time-range" />

          <MediaControlBar className="h-9 w-full items-center gap-3 bg-transparent px-4 py-1">
            <PlayButton />

            <MediaTimeDisplay
              showDuration
              noToggle
              className="ml-2 bg-transparent p-0 text-sm text-white"
            />

            <VolumeControl />

            <div className="ml-auto min-w-0 flex-1 truncate text-right text-sm font-semibold text-white">
              {title}
            </div>
            <MediaPipButton className="bg-transparent p-0">
              <span slot="enter">
                <PipIcon width={20} height={20} />
              </span>
              <span slot="exit">
                <PipIcon width={20} height={20} />
              </span>
            </MediaPipButton>
            <MediaFullscreenButton className="bg-transparent p-0">
              <span slot="enter">
                <FullScreenPlayerIcon width={20} height={20} />
              </span>
              <span slot="exit">
                <FullScreenPlayerIcon width={20} height={20} />
              </span>
            </MediaFullscreenButton>
          </MediaControlBar>
        </div>
      </MediaController>
    );
  }
);

export default Player;
